export default {
    username: 'IDまたはメールアドレス',
    password: 'パスワード',
    loginid: 'IDまたはメールアドレス'
};
